// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3_bYd","header":"MergedInvoice_header__2lOOV"};